import { common as jaCommon } from './ja/common';
import { common as zhCommon } from './zh/common';
import { common as enCommon } from './en/common';

const messages = {
  ja: {
    common: jaCommon,
  },
  zh: {
    common: zhCommon,
  },
  en: {
    common: enCommon,
  },
};

export default messages;
